import { P2 } from '@repo/ui/components/Typography';
import styled, { css } from 'styled-components';

import { ParagraphTypes } from './types';

const getParagraphStyles = (paragraphType: ParagraphTypes) => {
  switch (paragraphType) {
    case 'p0':
      return css`
        font-size: 18px;
        font-weight: var(--font-weight-regular);
        letter-spacing: -0.01em;
        line-height: 28px;
      `;
    case 'p1':
      return css`
        font-size: 16px;
        font-weight: var(--font-weight-regular);
        letter-spacing: -0.01em;
        line-height: 24px;
      `;
    case 'p2':
      return css`
        font-size: 14px;
        font-weight: var(--font-weight-medium);
        letter-spacing: -0.005em;
        line-height: 20px;
      `;
    case 'p3':
      return css`
        font-size: 12px;
        font-weight: var(--font-weight-medium);
        letter-spacing: -0.005em;
        line-height: 18px;
      `;
    default:
      return css``;
  }
};

export const TextWrapper = styled(P2)<{
  color?: string;
  paragraphType: ParagraphTypes;
}>`
  color: ${({ color }) => color || 'var(--color-text)'};

  p {
    ${({ paragraphType }) => getParagraphStyles(paragraphType)}

    & > b,
    & > strong {
      font-weight: var(--font-weight-semi-bold);
    }
  }

  p,
  ul,
  ol {
    margin: 0;
    color: ${({ color }) => color || 'var(--color-text)'};
  }

  ul,
  ol {
    padding-left: 22px;
  }

  li + li {
    margin-top: 12px;
  }

  p + p,
  ol + ol,
  ul + ul {
    margin-top: 12px;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    color: var(--color-text);
    font-size: 18px;
    font-weight: var(--font-weight-semi-bold);
    letter-spacing: -0.03em;
    line-height: 24px;
  }

  h1 + p,
  h2 + p,
  h3 + p,
  h4 + p,
  h5 + p {
    margin-top: 12px;
  }

  a {
    cursor: pointer;
    text-decoration: underline;
  }
`;
